import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import PdfViewerModal from "./modals/PdfViewerModal";
import ActionLink from "./controls/ActionLink";
import {userContext} from "./auth/Auth";

const $ = window.jQuery;

class Footer extends Component {
    state = {
        showConditionsModal: false
    };

    componentDidMount() {
        this.$el = $(this.el);
        this.$el.pxFooter();
    }

    componentWillUnmount() {
        this.$el.pxFooter('destroy');
    }

    render() {
        let context = userContext.get();
        let showConditions = context && context.roleSystemName === 'Provider';

        return (
            <footer ref={el => this.el = el} className="px-footer px-footer-bottom p-t-0">
                <div className="box m-a-0 bg-transparent">
                    <div className="box-cell col-md-3 p-t-3">
                        <h5 className="m-t-0 m-b-1 font-size-13">Информация</h5>
                        {/*<Link to="/contacts">О компании</Link>*/}
                        {/*<br />*/}
                        <a href="#" data-toggle="modal" data-target="#terms">Соглашение об использовании</a><br />
                        {
                            showConditions &&
                            <ActionLink onClick={() => this.setState({showConditionsModal: true})}>
                                Условия сотрудничества
                            </ActionLink>
                        }
                    </div>
                    <div className="box-cell col-md-3 p-t-3 valign-middle">
                        {/*<a href="https://play.google.com/store/apps" target="_blank">*/}
                            {/*<img src="/assets/img/google-play-badge.png" alt="Доступно в Google Play"*/}
                                 {/*style={{width: '153px'}} />*/}
                        {/*</a>*/}
                    </div>
                    <div className="box-cell col-md-3 p-t-3 valign-middle">
                        <a href="mailto:sales@rcc-rus.ru" className="display-block text-nowrap">
                            <i className="fa fa-envelope"/>&nbsp;&nbsp;info@netpal.ru
                        </a>
                        <a href="tel:74996475062" className="display-block text-nowrap">
                            <i className="fa fa-phone"/>&nbsp;&nbsp;+7 (499) 647-50-62
                        </a>
                    </div>
                </div>
                {
                    showConditions &&
                    <PdfViewerModal documentUrl={`${window.location.origin}/documents/Схема работы.pdf`}
                                    show={this.state.showConditionsModal}
                                    onHide={() => this.setState({showConditionsModal: false})}/>
                }
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js